import { render, staticRenderFns } from "./visitorDetails.vue?vue&type=template&id=486825d4"
import script from "./visitorDetails.vue?vue&type=script&lang=js"
export * from "./visitorDetails.vue?vue&type=script&lang=js"
import style0 from "./visitorDetails.vue?vue&type=style&index=0&id=486825d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports